import Axios from 'axios'
const { server } = (window as any).config

export default class Api<T> {
  dummyObject: T
  name: string

  host = server + '/'

  constructor(name: string) {
    this.dummyObject = {} as any
    this.name = name
  }

  async remove(id: any, rev: any): Promise<any> {
    Axios.defaults.withCredentials = true
    let response
    try {
      response = await Axios.delete(this.host + this.name + '/' + id + '?rev=' + rev)
    } catch (err) {}
    return response
  }

  async put(arg0: any) {
    Axios.defaults.withCredentials = true
    let response
    try {
      response = await Axios.post(this.host + this.name, arg0)
    } catch (err) {
      console.error('err', err)
    }
    return response
  }

  async find(arg0: {
    selector: any
    limit: number
    sort: { [x: string]: 'asc' | 'desc' }[] | undefined
  }) {
    Axios.defaults.withCredentials = true
    let response
    try {
      response = await Axios.post(this.host + this.name + '/_find', arg0)
    } catch (err) {}
    return response
  }

  async aggregate(arg0: {
    selector: any
    limit: number
    sort: { [x: string]: 'asc' | 'desc' }[] | undefined
  }) {
    Axios.defaults.withCredentials = true
    let response
    try {
      response = await Axios.post(this.host + this.name + '/aggregate', arg0)
    } catch (err) {}
    return response
  }

  async get(id: string) {
    Axios.defaults.withCredentials = true
    let response
    try {
      response = await Axios.get(this.host + this.name + '/' + id)
    } catch (err) {}
    return response
  }
}
